import { MutationHookOptions, useMutation } from '@apollo/client';

import { REMOVE_PARENT } from './mutations';

export const useDeleteParent = (options?: MutationHookOptions) => useMutation(REMOVE_PARENT, options);
